import { Grid } from '@mui/material';
import { DndProvider } from 'react-dnd';
import { FC, Fragment, useMemo } from 'react';
import { HTML5Backend } from 'react-dnd-html5-backend';
// components
import IngredientFields from './IngredientFields';
import DraggableIngredientRow from './DraggableIngredient';
// constants, interfaces, graphql, helper
import { getType } from 'lib/helper';
import { ProductFormulationTypes } from 'generated/graphql';
import { IngredientItemType, IngredientsCardProps } from 'interfaces';

const IngredientsCard: FC<IngredientsCardProps> = ({
  move,
  xl = 4,
  fields,
  onRemove,
  productType,
  isFactBox = false,
  productFormulationType,
}) => {
  const { type } = productFormulationType || {};

  const formulationType = useMemo(() => {
    if (productType && type) {
      return getType(productType, type as ProductFormulationTypes);
    }
    return [];
  }, [type, productType]);

  if (move) {
    return (
      <DndProvider backend={HTML5Backend}>
        <Grid container mt={2}>
          {fields?.map((item: IngredientItemType, index) => {
            const { ingredientId } = item || {};
            return (
              <Fragment key={ingredientId}>
                <Grid item xl={12} xs={12}>
                  <DraggableIngredientRow index={index} move={move} canDrag={(fields?.length ?? 0) > 1}>
                    <IngredientFields
                      item={item}
                      index={index}
                      xl={xl}
                      onRemove={onRemove}
                      formulationType={formulationType}
                      isFactBox={isFactBox}
                    />
                  </DraggableIngredientRow>
                </Grid>
              </Fragment>
            );
          })}
        </Grid>
      </DndProvider>
    );
  }

  // fallback: no drag-and-drop
  return (
    <Grid container mt={2}>
      {fields?.map((item: IngredientItemType, index) => {
        const { ingredientId } = item || {};
        return (
          <Fragment key={ingredientId}>
            <Grid item xl={12} xs={12}>
              <IngredientFields
                item={item}
                index={index}
                xl={xl}
                onRemove={onRemove}
                formulationType={formulationType}
                isFactBox={isFactBox}
              />
            </Grid>
          </Fragment>
        );
      })}
    </Grid>
  );
};

export default IngredientsCard;
